
import { requestStream, requestResponse } from './rsocketutils/rsocket.service'
import writetagvaluerequest from '@/model/requests/writetagvaluerequest';
import historydatarequest from '@/model/requests/historydatarequest';
import eventsdatarequest from '@/model/requests/eventsdatarequest';
import historydatabaserequest from '@/model/requests/historydatabaserequest';
import historydbtablerequest from '@/model/requests/historydbtablerequest'
import cardsrequest from '@/model/requests/cardsrequest';
import subscriberequest from '@/model/requests/subscriberequest';
import clientconfig from './service.utils';
import { NODE_CONTROL, publish, requestResponseMQTT, setOnNextTag, subscribe } from './mqttutils/mqttservice';

class TagsService {

   getalltags(request: subscriberequest, onnextCallback: (data: string) => void, errorCallback: (data: string) => void) {
      if (clientconfig.clientType) {
         setOnNextTag(onnextCallback)
         subscribe(request.subscription)
      }
      else {
         requestStream(request, 'tags/alltags', onnextCallback, errorCallback);
      }
   }

   tagupdate(tagname:string,request: writetagvaluerequest,
      responseCallback: (data: string) => void,
      errorCallback: (data: string) => void) {
      if (clientconfig.clientType) {
         if (tagname==null || request==null) return;
         publish(request.name, {name:tagname, tagvalue:request.tagvalue,datetime:request.datetime,quality:0})
      }
      else {
         requestResponse(request, "tags/writetag", responseCallback, errorCallback);
      }
   }

   gethistorydata(request: historydatarequest,
      onnextCallback: (data: string) => void,
      errorCallback: (data: string) => void) {
      if (clientconfig.clientType) {
         requestResponseMQTT(request, NODE_CONTROL.COMMANDS.TAG_HISTORY, onnextCallback, errorCallback)
      }
      else {
         requestResponse(request, "tags/historydata", onnextCallback, errorCallback)
      }
   }
   gethistorydatabase(request: historydatabaserequest,
      onnextCallback: (data: string) => void,
      errorCallback: (data: string) => void) {
      if (clientconfig.clientType) {
         requestResponseMQTT(request, NODE_CONTROL.COMMANDS.TAG_HISTORY_FROM_DB, onnextCallback, errorCallback)
      }
      else {
         requestResponse(request, "tags/historydatabase", onnextCallback, errorCallback)
      }
   }
   gethistorydbtable(request: historydbtablerequest,
      onnextCallback: (data: string) => void,
      errorCallback: (data: string) => void) {
      if (clientconfig.clientType) {
         requestResponseMQTT(request, NODE_CONTROL.COMMANDS.TAG_HISTORY_DB_TABLE, onnextCallback, errorCallback)
      }
      else {
         requestResponse(request, "tags/historydbtable", onnextCallback, errorCallback)
      }
   }
   geteventsdata(request: eventsdatarequest,
      onnextCallback: (data: string) => void,
      errorCallback: (data: string) => void) {
      if (clientconfig.clientType) {
         requestResponseMQTT(request, NODE_CONTROL.COMMANDS.TAG_EVENTS, onnextCallback, errorCallback)
      }
      else {
         requestResponse(request, "tags/eventsdata", onnextCallback, errorCallback)
      }
   }
   getCardsToSave(request: cardsrequest, responseCallback: (data: string) => void, errorCallback: (data: string) => void) {
      if (clientconfig.clientType) {
         requestResponseMQTT(request, 'cards/save', responseCallback, errorCallback);
      }
      else {
         requestResponse(request, 'cards/save', responseCallback, errorCallback);
      }

   }
   getCards(request: cardsrequest, responseCallback: (data: string) => void, errorCallback: (data: string) => void) {
      if (clientconfig.clientType) {
         requestResponseMQTT(request, 'cards/get', responseCallback, errorCallback);
      }
      else {
         requestResponse(request, 'cards/get', responseCallback, errorCallback);
      }
   }
}

export default new TagsService;